import {Component, ContentChild, TemplateRef, ViewChild} from '@angular/core'
import {DropdownContentDirective} from './dropdown-content.directive'

@Component({
  selector: 'cft-dropdown',
  templateUrl: './dropdown.component.html',
  exportAs: 'cftDropdown',
})
export class DropdownComponent {
  @ViewChild('root') rootTemplate!: TemplateRef<unknown>
  @ContentChild(DropdownContentDirective) content!: DropdownContentDirective
}
